import * as layouts from "./index";
import React from "react";
import { PageProps } from "@/getServerSideProps/getServerSideProps";

type Layout = (props: PageProps) => React.ReactNode;

type LayoutMap = { [name: string]: Layout };

export const layoutMap: LayoutMap = layouts;
